import type { FC } from "react";
import { useState } from "react";
import { Minus, Plus } from "lucide-react";

import type { PatientProps } from "@/components/patient/patient-profile";
import { Button } from "@/components/ui/button";
import DiseaseLabel from "@/components/ui/disease-label";
import { getDiseases } from "@/utils/patient";

const DiseasesCell: FC<PatientProps> = ({ patient }) => {
  const diseases = getDiseases(patient);
  const [showAll, setShowAll] = useState(false);
  const isDiabetic = diseases.diabet !== "NONE";
  const renderLimit = showAll ? diseases.associatedPathologies.length : 2;

  return (
    <div className="flex flex-wrap gap-1 max-w-[200px]">
      <DiseaseLabel disease={diseases.disease} />
      {isDiabetic ? <DiseaseLabel disease={diseases.diabet} /> : null}
      {diseases.associatedPathologies.map((pathology, index) =>
        (isDiabetic && index < renderLimit) ||
        (!isDiabetic && index < renderLimit + 1) ? (
          <DiseaseLabel
            key={`pathology-label-${pathology.toLowerCase()}`}
            disease={pathology}
          />
        ) : null
      )}
      {(isDiabetic && diseases.associatedPathologies.length > 2) ||
      (!isDiabetic && diseases.associatedPathologies.length > 3) ? (
        <Button
          type="button"
          variant="text"
          size="none"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? (
            <Minus width={20} height={20} color="#475569" />
          ) : (
            <Plus width={20} height={20} color="#475569" />
          )}
        </Button>
      ) : null}
    </div>
  );
};

export default DiseasesCell;
